'use strict';



export function getModel (state) {
    return state
        && state[window.version]
        && state[window.version].model
        ?  state[window.version].model : null;
}


export function replaceState (model) {
    window.history.replaceState({
        ...window.history.state,
        [window.version]: { model }
    }, '');
}
